export enum ShipmentMethod {
  PICKUP = 'Самовывоз',
  TK = 'Транспортной компанией',
  AVITO = 'Авито доставка',
}

export enum ShipmentCompany {
  DEL_LIN = 'Деловые линии',
  SDEK = 'СДЕК',
  PEK = 'ПЭК',
}